export const getMatchingBenefitOption = (benefitOptions, labels) => {
    const benefitOption = benefitOptions
        .find(benefitOption => labels.includes(benefitOption.label));
    return benefitOption
        ? benefitOption.value
        : '0';
};
